import React from 'react';
import { Grid, List } from 'semantic-ui-react';
import { MenuCategoryPropType } from '../../../../../../services/proptypes';
import { MenuConsumer } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import ItemContainer from '../../item/ItemContainer';
import CategoryHeader from '../components/CategoryHeader/CategoryHeader';
var defaultProps = {
  scheduleCategories: []
};
var CategoryTwoSides = function CategoryTwoSides(_ref) {
  var category = _ref.category,
    scheduleCategories = _ref.scheduleCategories;
  return /*#__PURE__*/React.createElement("section", {
    className: "category-variant category-two-sides"
  }, /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref2) {
    var items = _ref2.items;
    var itemIds = category.items,
      name = category.name;
    var categoryItems = MenuUtil.getCategoryItems(itemIds, items);
    var displayImages = MenuUtil.hasImageInSomeItems(categoryItems);
    return /*#__PURE__*/React.createElement(Grid, {
      stackable: true,
      columns: 2,
      id: name,
      className: "category-container"
    }, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Column, {
      className: "header-column"
    }, /*#__PURE__*/React.createElement(CategoryHeader, {
      category: category,
      scheduleCategories: scheduleCategories
    })), /*#__PURE__*/React.createElement(Grid.Column, {
      className: "category-container-content"
    }, /*#__PURE__*/React.createElement(List, null, categoryItems.map(function (_ref3) {
      var itemId = _ref3._id;
      return /*#__PURE__*/React.createElement(ItemContainer, {
        key: itemId,
        itemId: itemId,
        displayImages: displayImages
      });
    })))));
  }));
};
CategoryTwoSides.defaultProps = defaultProps;
export default CategoryTwoSides;